module.exports = __webpack_public_path__ + "img/magento-modules-customization_small@2x.d52c861b.jpg";